import * as React from 'react';
import type { SVGProps } from 'react';

const SvgLinkAnchor = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path
      fill="#f32a52"
      d="m14.705 7.55-2.393 2.393a4.422 4.422 0 0 1-6.255 0 .948.948 0 1 1 1.335-1.335 2.543 2.543 0 0 0 3.577 0l2.393-2.393a2.53 2.53 0 1 0-3.577-3.577l-.758.766A.95.95 0 1 1 7.684 2.06l.766-.766a4.423 4.423 0 1 1 6.255 6.255Zm-7.732 5.046-.758.766a2.53 2.53 0 1 1-3.577-3.577L5.03 7.392a2.543 2.543 0 0 1 3.577 0 .948.948 0 0 0 1.335-1.335 4.414 4.414 0 0 0-6.255 0L1.295 8.45a4.423 4.423 0 1 0 6.255 6.255l.766-.766a.95.95 0 1 0-1.343-1.343Z"
    />
  </svg>
);
export default SvgLinkAnchor;
